import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '../../../shared/components/alert/Alert';
import { DropDown } from '../../components/dropDown/DropDown';

function ProfileDepartmentFields({
  profile,
  active,
  onChange,
  label,
  defaultValue,
  subDeptsArr,
  hasDepartmentError,
  hasSubDepartmentError,
  departmentErrorText,
  subDepartmentErrorText,
  isAfterSubmit,
}) {
  const { t } = useTranslation();

  const handleDepartmentChange = (event) => {
    onChange.department(event);
  };

  const handleSubDepartmentChange = (event) => {
    onChange.subDepartment(event);
  };

  return (
    <>
      {profile.departments?.length > 1 && profile.access !== '2' && (
        <fieldset className={`account_details_container${hasDepartmentError ? ' error' : ''}`}>
          <legend className="not_logged_label" id="department-legend">
            {hasDepartmentError && isAfterSubmit && (
              <span className="error-indicator">{t('error')}</span>
            )}
            {label.department}
            {t('input.label.required')}
          </legend>
          <div>
            <div className="select-cont">
              <DropDown
                defaultValue={defaultValue.department}
                options={profile.departments}
                value={active.department}
                onChange={handleDepartmentChange}
                id="department"
              />
            </div>
          </div>
          <Alert
            id="department-error-alert"
            isVisible={hasDepartmentError}
            message={departmentErrorText}
            type="error"
            variant="outline"
            size="md"
          />
        </fieldset>
      )}
      {subDeptsArr?.length > 0 && profile.access !== '2' && (
        <fieldset className={`account_details_container${hasSubDepartmentError ? ' error' : ''}`}>
          <legend className="not_logged_label" id="sub-department-legend">
            {hasSubDepartmentError && isAfterSubmit && (
              <span className="error-indicator">{t('error')}</span>
            )}
            {label.subDepartment}
            {t('input.label.required')}
          </legend>
          <div>
            <div className="select-cont">
              <DropDown
                defaultValue={defaultValue.subDepartment}
                options={subDeptsArr}
                value={active.subDepartment}
                onChange={handleSubDepartmentChange}
                id="sub-department"
              />
            </div>
          </div>
          <Alert
            id="sub-department-error-alert"
            isVisible={hasSubDepartmentError}
            message={subDepartmentErrorText}
            type="error"
            variant="outline"
            size="md"
          />
        </fieldset>
      )}
    </>
  );
}

export default ProfileDepartmentFields;
